import type { SxProps, Theme } from '@mui/material/styles';

/** Full-width `FormControlLabel` + `Switch` row (`labelPlacement="start"`). */
export const switchFormRowLabelSx: SxProps<Theme> = {
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& .MuiFormControlLabel-label': {
    flex: 1,
    minWidth: 0,
  },
  '& .MuiSwitch-root': {
    flexShrink: 0,
  },
};
